import { zPayPinForm } from "@zoox-framework/zoox-components";
import CompanyService from "@/services/CompanyService";
import CardService from "@/services/CardService";
import OrderService from "@/services/OrderService";
import PaymentHeader from "../../../../components/PaymentHeader/PaymentHeader.vue";
import Create from "../../../views/Card/Create/Create.vue";
import PaymentService from "@/services/PaymentService";
import PersonService from "@/services/PersonService";
import PaymentMethod from "@/components/PaymentMethod/PaymentMethod.vue";
import PaymentCanceled from "@/components/PaymentCanceled/PaymentCanceled.vue";
import moment from "moment";
import Vue from "vue";
import { mapActions } from "vuex";

export default {
  name: "PaymentSolicitations",
  components: {
    "z-pay-pin-form": zPayPinForm,
    PaymentMethod: PaymentMethod,
    PaymentCanceled: PaymentCanceled,
    PaymentHeader,
    Create
  },
  data() {
    return {
      personService: new PersonService(),
      companyService: new CompanyService(),
      orderService: new OrderService(),
      paymentService: new PaymentService(),
      cardService: new CardService(),
      company: {},
      order: {},
      debits: [],
      value: 0,
      charges: [],
      step: -1,
      chargeId: "",
      solicitations: true,
      pin: false,
      paymentMethod: false,
      paymentCanceled: false,
      paymentValue: 0,
      currency: "BRL",
      checkinDate: "",
      checkoutDate: "",
      currentCharge: {},
      shouldShowMessage: false,
      loadingPayment: false,
      initialized: null
    };
  },
  created() {
    this.initialized = this.init();
  },
  async mounted() {
    await this.initialized;
    this.step++;
    Vue.$globalEvent.$on("reload", async (reloadCharges = false) => {
      if (reloadCharges) {
        const token = this.$store.getters.getChargeToken;
        const pending = await this.orderService.getCharges(this.order.orderId, {
          status: "pending"
        });
        this.charges = (pending || []).filter(c => c.token === token);
      }
      this.showLoading = false;
      this.solicitations = true;
      this.pin = false;
      this.paymentMethod = false;
      this.paymentCanceled = false;
      this.loadingPayment = false;
      this.$store.dispatch("$setIsValidated", false);
    });
    if (this.$store.state.isValidated === true) {
      this.solicitations = false;
      this.pin = false;
      this.paymentMethod = true;
      this.currentCharge = this.$store.state.currentCharge;
      this.paymentValue = this.$store.state.paymentValue;
    } else {
      this.company = this.companyService.getCurrentCompany();
      this.order = this.$store.getters.getCurrentOrder;

      if (this.order != null) {
        this.order.orderId = this.order.id || this.order._id;
        this.currency = this.order.currency || this.currency;
        // this.charges já contém só a cobrança do link (resolvida em init()).
        let itemsIds = [];
        this.charges.forEach(charge => {
          charge.items.forEach(function(item) {
            itemsIds.push(item.id);
          });
        });
        const items = await this.orderService.getBulkItems(itemsIds);
        items.forEach(item => {
          const percentLeft = item.percentLeft || 100;
          const itemValue = (item.amount * item.quantity * percentLeft) / 100;
          this.debits.push({
            name: item.description,
            price: itemValue
          });
        });
        this.checkinDate = moment
          .utc(this.order.metadata.checkinDate)
          .endOf("day")
          .format(this.$t("GLOBAL.DATE_FORMAT"));
        this.checkoutDate = moment
          .utc(this.order.metadata.checkoutDate)
          .endOf("day")
          .format(this.$t("GLOBAL.DATE_FORMAT"));
        if (this.charges.length === 0) {
          this.shouldShowMessage = true;
        }
      } else {
        this.shouldShowMessage = true;
      }
    }
  },
  methods: {
    ...mapActions(["$setCurrentCharge", "$setIsValidated"]),
    async init() {
      const personId = this.personService.getPersonId();
      const token = this.$store.getters.getChargeToken;
      this.charges = [];
      this.order = this.$store.getters.getCurrentOrder;

      if (this.order == null) return;

      try {
        const pending = await this.orderService.getCharges(this.order.id, {
          status: "pending"
        });

        // paga a cobrança que veio no link, nunca a primeira pendente do
        // pedido. charges[0] só é a cobrança certa quando o pedido tem uma única
        // pendente; com mais de uma, o hóspede caía na cobrança de outro.
        const charge = (pending || []).find(c => c.token === token);
        if (!charge) return;

        this.charges = [charge];
        this.order = await this.orderService.getOrderById(charge.order.id);

        await this.paymentService.updatePersonCharge(personId, charge.token);
        this.currentCharge = await this.orderService.getChargeByToken(
          charge.token
        );

        this.$store.dispatch("$setCurrentOrder", this.order);
        this.paymentValue = this.currentCharge.amount;
        this.shouldShowMessage = false;
      } catch (err) {
        // sem isso a tela ficava viva mas sem botão de pagar
        console.error(err);
        this.charges = [];
        this.$toaster.error(this.$t("GLOBAL.ERROR"));
      }
    },
    openViewStatement(obj) {
      this.value = obj.amount;
      this.debits = obj.debits;
      this.dialogExpenseVisible = true;
    },
    getGeolocation() {
      return new Promise((resolve, reject) => {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(({ coords }) =>
            resolve(coords)
          );
        } else {
          reject("Geolocation services are not supported by your browser");
        }
      });
    },

    successPayment() {
      this.$setCurrentCharge(this.currentCharge);
      this.$setIsValidated(true);
      this.$router.push("/payment/checkout");
    },

    async Pay(id, value, charge) {
      this.loadingPayment = true;
      const updatedCharge = await this.orderService.getChargeByToken(
        charge.token
      );

      if (updatedCharge.status === "pending") {
        this.paymentService.generatePin(this.order.orderId, id);
        this.chargeId = id;
        this.paymentValue = value;
        this.currentCharge = charge;
        this.solicitations = false;
        this.pin = true;
      } else {
        this.paymentCanceled = true;
      }
    },
    ValidatePin(validated) {
      if (validated === true) {
        this.$store.dispatch("$setCurrentCharge", this.currentCharge);
        this.$store.dispatch("$setPaymentValue", this.paymentValue);
        this.$store.dispatch("$setIsValidated", true);
        this.pin = false;
        this.paymentMethod = true;
      } else {
        this.$toaster.error(this.$t("PAYMENT_SOLICITATION.PIN_NOT_VALID"));
      }
    },
    async submitPin({ orderId, pinNumber, chargeId }) {
      const resp = await this.paymentService.validatePin(
        orderId,
        pinNumber,
        chargeId
      );
      this.ValidatePin(resp);
    },
    async forgotPin({ orderId, chargeId }) {
      await this.paymentService.generatePin(orderId, chargeId);
      this.$toaster.success(this.$t("PAYMENT_SOLICITATION.PIN_GENERATED"));
    }
  }
};
